<span *ngIf="classification === EHarshDrivingEventClassification.Collision"
  i18n="@@S_LIVEMAP_HDE_COLLISION_EVENT">Collision event</span>
<span *ngIf="classification === EHarshDrivingEventClassification.Dangerous"
  i18n="@@S_LIVEMAP_HDE_DANGEROUS_EVENT">Dangerous event</span>
<span *ngIf="classification === EHarshDrivingEventClassification.HarshDriving"
  i18n="@@S_LIVEMAP_HDE_HARSH_DRIVING_EVENT">Harsh Driving event</span>
<span *ngIf="classification === EHarshDrivingEventClassification.LowRisk"
  i18n="@@S_LIVEMAP_HDE_LOW_RISK_EVENT">Low Risk event</span>
<span *ngIf="classification === EHarshDrivingEventClassification.Undetermined"
  i18n="@@S_LIVEMAP_HDE_UNDETERMINED_EVENT">Undetermined event</span>
